<template>
    <div class="comment-like-button mr-3">
        <a class="small" :class="{active: liked}" v-on:click="toggleLike">
            Like
        </a>
    </div>
</template>

<script>
export default {
    props: {
        comment: {
            type: Object
        },
        commentLikes: {
            type: Array,
            default() {
                return [];
            }
        },
        user: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    methods: {
        toggleLike() {
            this.$emit('likeToggled', {
                comment_id: this.comment.id
            })
        }
    },
    computed: {
        liked() {
            return this.commentLikes.filter(like => like.employee_id === this.user.employee_id).length > 0;
        },
        likeList() {
            return this.commentLikes.filter((like, index) => (index + 1) <= 10);
        },
        likesNotShownCount() {
            return this.commentLikes.length - this.likeList.length;
        }
    }
}
</script>

<style lang="scss" scoped>
.comment-like-button {
    line-height: 0;

    a {
        line-height: 1;

        &.active {
            color: #022A8A;
        }
    }
}

</style>
